export const base = {
  baseUrl: import.meta.env.VITE_BASE_URL,
  isProduction: import.meta.env.VITE_ENV === 'production',
  apiIdpServiceUrl: import.meta.env.VITE_API_IDP_SERVICE_URL,
  apiServiceUrl: import.meta.env.VITE_API_SERVICE_URL,
  webAppBaseUrl: import.meta.env.VITE_APP_BASE_URL,
}
